export default "__VITE_ASSET__PrlWZl2d__"